<template>
  <base-row v-bind="$props">
    <td>
      {{ item.location ? item.location.name : '-' }}
    </td>

    <td>
      {{ item.source_received_at ? _date(item.source_received_at) : '-' }}
    </td>

    <td>
      <Link
        v-if="hasRoute"
        :href="packageShowRoute"
        class="uppercase font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ item.details?.tag_num ? item.details.tag_num.slice(-5) : 'Not named' }}
      </Link>
      <span
        v-else
        class="text-blue-600 hover:text-blue-600"
      >
        {{ item.details?.tag_num ? item.details.tag_num.slice(-5) : 'Not named' }}
      </span>
      <!--            Product: {{ item.product_name || "Not assigned" }}-->
    </td>

    <td>
      <div
        v-if="item.product"
        class="mb-2"
      >
        <Link
          v-if="item.product"
          :href="route('products.show', { product: item.product.id })"
          class="uppercase font-semibold text-blue-600 hover:text-blue-600"
          @click.prevent="assign()"
        >
          {{ item.product.name }}
          <br />
        </Link>

        <span
          v-if="item.product?.sku"
          class="text-xs"
        >
          SKU: {{ item.product.sku }}
          <br />
        </span>
      </div>

      <a
        href="#"
        class="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md shadow-sm bg-gray-200 text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        @click.prevent="assign()"
      >
        Pair Product
      </a>
    </td>

    <td>
      {{ item.source_product_name || '-' }}
    </td>

    <td>{{ item.source_quantity }} {{ item.source_quantity_unit }}</td>

    <td>
      {{ item.quantity || '-' }}
    </td>

    <td>
      <basic-badge
        v-if="item.published_at"
        color="green"
      >
        Published
      </basic-badge>
      <basic-badge
        v-else
        color="gray"
      >
        Draft
      </basic-badge>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import _date from '@/Filters/Date'
import _percent from '@/Filters/Percent'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a package
     */
    packageShowRoute() {
      return this.showRoute(this.item)
    },
    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.packageShowRoute !== null
    }
  },
  methods: {
    _date,
    _percent,
    assign() {
      console.log('emit assign', this.item)
      this.$emit('assign', this.item)
    }
  }
}
</script>
